module.exports = __webpack_public_path__ + "935ec3281c5339875bc0a4b6e3ab598c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-320.webp.png
// module id = 203
// module chunks = 0